const ATS_TEMPLATES = ['ats-classic', 'ats-modern', 'ats-compact'];

const DESIGN_TEMPLATES = [
    'template1', 'template2', 'template3', 'template4', 'template5', 'template6',
    'template7', 'template8', 'template9', 'template10', 'template11', 'template12',
];

const TEMPLATES = [...ATS_TEMPLATES, ...DESIGN_TEMPLATES];

const TEMPLATE_LABELS = {
    'ats-classic': 'ATS Classic',
    'ats-modern': 'ATS Modern',
    'ats-compact': 'ATS Compact',
    template1: 'Theme 1', template2: 'Theme 2', template3: 'Theme 3', template4: 'Theme 4',
    template5: 'Theme 5', template6: 'Theme 6', template7: 'Theme 7', template8: 'Theme 8',
    template9: 'Theme 9', template10: 'Theme 10', template11: 'Theme 11', template12: 'Theme 12',
};

const FONTS = [
    'helvetica', 'monospace', 'sansserif', 'gill-sans',
    'courier', 'roboto', 'barlow', 'gothic', 'funky',
];

export { TEMPLATES, ATS_TEMPLATES, DESIGN_TEMPLATES, TEMPLATE_LABELS, FONTS };